import { Component, Input } from '@angular/core';
import { FilterService } from '@lobos/library';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-active-filter-list]',
  templateUrl: './active-filter-list.component.html',
  styleUrls: ['./active-filter-list.component.scss'],
})
export class ActiveFilterListComponent {
  @Input() filters: any;

  constructor(protected filterService: FilterService) {}

  /** remove the choosen filter */
  removeFilter(filter: any) {
    this.filterService.removeFilterWithParam(filter.value, filter.name);
  }

  /** removes all filters */
  removeAllFilters() {
    this.filterService.clearFilters();
  }
}
